/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Link_Error_CancelledInputs */

const vi_vtp_link_error_cancelled = /** @type {(inputs: Vtp_Link_Error_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vận đơn đã huỷ, không gắn được`)
};

/**

* @param {Vtp_Link_Error_CancelledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_link_error_cancelled = /** @type {((inputs?: Vtp_Link_Error_CancelledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Link_Error_CancelledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_link_error_cancelled(inputs)
});